import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
// import store from '@/store'
import { localStorage } from '@/utils/storage'

// create an axios instance
const baseURL = process.env.VUE_APP_BASE_API
const service = axios.create({
    //开发
    baseURL,
    timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent

        // if (store.getters.token) {
        // let each request carry token
        // ['xy-web-token'] is a custom headers key
        // please modify it according to the actual situation
        if (localStorage.get('language')) {
            let type = {
                'zh': '1',
                'en': '2'
            }
            if (config.method == 'post') {
                config.data = {
                    ...config.data,
                    show_type: type[localStorage.get('language')]
                }
            } else if (config.method == 'get') {
                config.params = {
                    ...config.params,
                    show_type: type[localStorage.get('language')]
                }
            }

            // config.data.show_type = localStorage.get('language')
        }
        const token = localStorage.get('xy-web-token')
        config.headers['Authorization'] = token
            // }
        return config
    },
    error => {
        // do something with request error
        // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
            // if the custom code is not 20000, it is judged as an error.
            // const isBlob = res instanceof Blob
        if (res.code !== 0) {
            Message({
                    message: res.msg || 'Error',
                    type: 'error',
                    duration: 5 * 1000
                })
                // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
            if (res.code === 401 || res.code === 50012 || res.code === 50014) {
                // to re-login
                // MessageBox.confirm('登录已过期，请重新登录', '确定登出', {
                //   confirmButtonText: '重新登录',
                //   cancelButtonText: '取消',
                //   type: 'warning'
                // }).then(() => {
                //   // store.dispatch('user/resetToken').then(() => {
                //   //   location.reload()
                //   // })
                // })
                if (localStorage.get("xy-web-token")) {
                    Message.error('登录已过期，请重新登录')
                    localStorage.remove("xy-web-userInfo")
                    localStorage.remove("xy-web-token")
                    setTimeout(() => {
                        location.href = baseURL.slice(0, -2)
                    }, 1000)
                }
            }
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            return res
        }
    },
    error => {
        // for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service